import { IProcessingStatus } from "../SLEntriesDetails";

export function mergeProcessingStatuses(a: IProcessingStatus, b: IProcessingStatus): IProcessingStatus {
  if (Object.keys(a).length === 0) {
    return b;
  }
  if (Object.keys(b).length === 0) {
    return a;
  }
  return {
    errors: a.errors + b.errors,
    successes: a.successes + b.successes,
    statuses: Object.assign(a.statuses, b.statuses)
  };
}
